import React from 'react';
import { Button } from '@chakra-ui/react';
import { FaSync, FaPrint, FaFileExport } from 'react-icons/fa';
import '../../../pages/Css/Header.module.css';

function HeaderSection({ title, breadcrumb }) {

    return (
        <div className="teacher-list-container">
            <div className="header">
                {/* Use Chakra's Heading component and apply color from useColors */}
                <h1 fontSize="20px" color='teal'>{title}</h1>
                {/* <div className="action-buttons">
                    <Button
                        className="refresh-button"
                        boxShadow="md" // Applies a medium shadow
                        backgroundColor='white'
                        fontSize='11px'
                        onClick={() => {
                            // Add refresh functionality here
                            console.log('Refresh button clicked');
                        }}
                    >
                        <FaSync color='#515B73' />
                    </Button>
                    <div className="export-dropdown" >
                        <Button className="export-button" display={{ base: 'none', md: 'flex' }}
                            backgroundColor='white' fontSize='11px' boxShadow="md">
                            <FaPrint color='#515B73' />
                            Print PDF
                        </Button>
                    </div>
                    <div className="export-dropdown">
                        <Button
                            className="export-button"
                            display={{ base: 'none', md: 'flex' }}
                            backgroundColor='white'
                            fontSize='11px'
                            boxShadow="md"
                        >
                            <FaFileExport color='#515B73' />
                            Export
                        </Button>
                    </div>
                </div> */}

            </div>
            <div className="breadcrumb">
                {breadcrumb.map((item, index) => (
                    <span key={index}>
                        {item}
                        {index < breadcrumb.length - 1 && " / "}
                    </span>
                ))}
            </div>
        </div>
    );
}

export default HeaderSection;
